import BaseService from '@/ecm/common/BaseService.js';

class AlertService {
  baseUrl = 'alert';

  save = (alert) => BaseService.post({ url: `${this.baseUrl}`, data: alert });
  update = (id, alert) => BaseService.put({ url: `${this.baseUrl}/${id}`, data: alert });
  getDocumentList = (documentId) => BaseService.get({ url: `${this.baseUrl}/document/${documentId}` });
  getUserAlerts = () => BaseService.get({ url: `${this.baseUrl}/user` });
  remove = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  removeUserAlerts = (alertIds) => {
    const params = new URLSearchParams();
    alertIds.forEach(id => params.append('alertIds', id));

    return BaseService.delete({ url: `${this.baseUrl}/user-alerts?${params.toString()}` });
  };
}

export default new AlertService();
